import React from "react";
import PropTypes from "prop-types";

import { Empty, Button } from "antd";

class EmptyActionContainer extends React.Component {
    render() {
        const { action, name, description } = this.props;
        return (
            <Empty description={<span>{description}</span>}>
                <Button type="primary" onClick={action}>
                    {name}
                </Button>
            </Empty>
        );
    }
}

EmptyActionContainer.propTypes = {
    action: PropTypes.func,
    name: PropTypes.string,
    description: PropTypes.string
};

export default EmptyActionContainer;
